// extracted by mini-css-extract-plugin
var _1 = "EmailTableRowActivitiesContent-modulecontent__hBbrC";
var _2 = "EmailTableRowActivitiesContent-moduleicon__l3QMA";
var _3 = "EmailTableRowActivitiesContent-modulelabel__ZUPjZ";
export { _1 as "content", _2 as "icon", _3 as "label" }
